import { AvailabilityForm } from '../types';

export const getSelectedTimeslotsWithStaffAndRoomAllocation = (
  allGuestExperiences: { bookings: (AvailabilityForm | undefined | null)[] }[]
) => {
  const { selectedTimeslotsWithStaffAndRoomAllocation } = (allGuestExperiences || []).reduce(
    (
      acc: {
        allocatedStaffMap: Map<string, string[]>;
        allocatedRoomsMap: Map<string, string[]>;
        selectedTimeslotsWithStaffAndRoomAllocation: string[];
      },
      curr,
      guestIndex
    ) => {
      curr?.bookings?.forEach((ts) => {
        if (ts) {
          const {
            allocatedRoomsMap,
            allocatedStaffMap,
            selectedTimeslotsWithStaffAndRoomAllocation,
          } = acc;
          const unavailableStaffForTimeslot = allocatedStaffMap.get(
            `${guestIndex}-${ts.dayNumber}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`
          );
          const unavailableRoomsForTimeslot = allocatedRoomsMap.get(
            `${guestIndex}-${ts.dayNumber}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`
          );
          const staffId = ts?.staff?.find((s) => !unavailableStaffForTimeslot?.includes(s));
          const roomId = ts?.rooms?.find((r) => !unavailableRoomsForTimeslot?.includes(r));
          if (staffId && roomId) {
            allocatedStaffMap.set(
              `${guestIndex}-${ts.dayNumber}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`,
              [...(unavailableStaffForTimeslot || []), staffId]
            );
            allocatedRoomsMap.set(
              `${guestIndex}-${ts.dayNumber}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`,
              [...(unavailableRoomsForTimeslot || []), roomId]
            );
            selectedTimeslotsWithStaffAndRoomAllocation.push(
              `${guestIndex}-${ts.dayNumber}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}-${ts.endTime}-${staffId}-${roomId}`
            );
          }
        }
      });
      return acc;
    },
    {
      allocatedStaffMap: new Map<string, string[]>(),
      allocatedRoomsMap: new Map<string, string[]>(),
      selectedTimeslotsWithStaffAndRoomAllocation: [],
    }
  );
  return selectedTimeslotsWithStaffAndRoomAllocation;
};
